import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getUserInfoApi, publicCurrency } from '@/utils/api/common';
interface UserInfo {
  [key: string]: string | number | any[]
}
interface FormatCurrencyListInterface {
  [key: string]: string | number
}
export interface LangState {
  value: string,
  currencyList: any[],
  formatCurrencyList: FormatCurrencyListInterface[],
  optionalCountryId: number | string,
  currency: string,
  saleCountry: Array<{ id: number, name: string }>
  company_info: UserInfo,
  user_info: UserInfo
}

const initialState: LangState = {
  value: localStorage.getItem('language') || 'zh',
  currency: localStorage.getItem('currency') || 'CNY',
  currencyList: [],
  formatCurrencyList: [],
  saleCountry: [],
  optionalCountryId: window.localStorage.getItem('optionalCountryId') || '3756',
  company_info: {},
  user_info: {}
};

export const asyncPublicCurrency: any = createAsyncThunk('lang/asyncPublicCurrency', async (_, { getState }) => {
  const { data: { data = {}, code } } = await publicCurrency();
  const { lang: { currencyList = [] } } = getState() as any;
  if (+code === 0) {
    const { list = [] } = data as any;
    return list;
  } else {
    return currencyList;
  }
});
export const asyncUserInfo: any = createAsyncThunk('lang/asyncUserInfo', async (_, { getState }) => {
  const { data: { data = {}, code } } = await getUserInfoApi();
  const { lang: { company_info, user_info } } = getState() as any;
  if (+code === 0) {
    const { company_info, user_info } = data as { company_info: UserInfo, user_info: UserInfo, token: string | undefined };
    window.localStorage.setItem('company_info', JSON.stringify(company_info));
    window.localStorage.setItem('user_info', JSON.stringify(user_info));
    // window.localStorage.setItem('token', token || '');
    // window.localStorage.setItem('user_id', user_info?.id?.toString() || '');
    return { company_info, user_info };
  } else {
    return { company_info, user_info };
  }
});

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    langChange: (state: any, payload) => {
      const { currency, language } = payload.payload;
      state.currency = currency;
      state.value = language;
      localStorage.setItem('language', language);
      localStorage.setItem('currency', currency);
    },
    saleCountryChange: (state: any, payload) => {
      state.saleCountry = payload.payload;
    },
    optionalCountryChange: (state, payload) => {
      state.optionalCountryId = payload.payload;
      localStorage.setItem('optionalCountryId', payload.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncPublicCurrency.fulfilled, (state, { payload = [] }) => {
        state.currencyList = payload;
        state.formatCurrencyList = payload.reduce((prev: any, curr: { exchange_rate: any; }) => ({ ...prev, ...curr.exchange_rate }), {});
      })
      .addCase(asyncUserInfo.fulfilled, (state, { payload = {} }) => {
        const { company_info, user_info } = payload;
        state.company_info = company_info;
        state.user_info = user_info;
      });
  }
});

export const { langChange, optionalCountryChange, saleCountryChange } = langSlice.actions;
export const selectedLang = (state: RootState) => state.lang.value;

export default langSlice.reducer;
